import { NextPage } from 'next'

import DownloadApps from '@/components/downloadApps'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import PageHeader from '@/components/pageHeader'
import Picture from '@/components/picture'
import appList from '@/constants/healthGrowth'
import STRINGS from '@/constants/strings'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.HEALTH_GROWTH.PAGE_TITLE,
      description: STRINGS.HEALTH_GROWTH.PAGE_DESCRIPTION,
    },
  }
}

const HealthGrowthYieldProtection: NextPage = () => {
  return (
    <LayoutWithNavigation>
      <section className="px-6 my-4 max-w-7xl m-auto">
        <PageHeader
          heading={STRINGS.HEALTH_GROWTH.HEALTH_AND_GROWTH}
          subHeading={STRINGS.HEALTH_GROWTH.YIELD_PREDICTION}
        />
        <section className="flex md:flex-row flex-col">
          <div className="md:flex-1 pt-4">
            <p className="whitespace-pre-wrap mb-2.5 text-footer-grey text-base font-natosans-light">
              {STRINGS.HEALTH_GROWTH.DESCRIPTION}
            </p>
            <div className="py-2.5">
              <DownloadApps apps={appList} />
            </div>
          </div>
          <div className="md:w-1/3 md:px-4 py-2.5">
            <Picture
              image="/assets/images/health-growth/health"
              imageAlt="soybean growth in farm with blue sky background. agriculture plant seeding growing step concept"
              loading="eager"
              imageStyle="w-full"
            />
          </div>
        </section>
      </section>
    </LayoutWithNavigation>
  )
}

export default HealthGrowthYieldProtection
